import { _js } from '@ifixit/localize';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { getOrCreateHandle } from 'Shared/prosemirror/answers';
import { getSerializedText, getText } from 'Shared/prosemirror/tiptap/editor_cache';
import { getWordCount } from 'Shared/utils/wordcount';

const prosemirror = document.querySelector('#qaEditor');
const editorid = getOrCreateHandle(prosemirror, '#editor');

const QuestionAsk = {
   lastDevice: false,
   lastTitle: false,
   lastText: false,

   updateTitleRecommendations: function (ev) {
      if (App.isEdit) {
         return;
      }

      let device = false;
      when($('qaDevice'), el => {
         device = el.get('value');
         if (device.startsWith('Example:')) {
            device = false;
         }
      });

      let title = $('qaTitle').get('value');
      let text = getSerializedText(editorid);
      if (title.startsWith('Example:')) {
         title = false;
      }

      if (
         device == QuestionAsk.lastDevice &&
         title == QuestionAsk.lastTitle &&
         text == QuestionAsk.lastText
      ) {
         device = false;
      }

      QuestionAsk.lastDevice = device;
      QuestionAsk.lastTitle = title;
      QuestionAsk.lastText = text;

      let toSend = {
         device: device,
         title: title,
         text: text,
      };

      if (device && title) {
         window.trackClickExistingQuestion = obj => {
            trackAnalyticsCustomEvent(obj);
         };
         new Request.AjaxIO('getRecommendationContent', {
            onSuccess: function (html) {
               if (html) {
                  $('recommendationContainer').set('html', html);
               }
            },
         }).send(toSend);
      }
   },

   handleQualityBar: function (qualityPoints) {
      let qualityBar = $$('.js-title-quality-bar');
      let colorBar = qualityBar.getElement('.js-color-bar');
      let qualityText = qualityBar.getElement('.js-quality-text');
      let quality = '';
      let score = 0;
      let qaTitleLabel = $$('.js-qa-title-label');

      score = Math.ceil(Math.min(qualityPoints * 10, 100) / 20);

      switch (score) {
         case 1:
         case 2: {
            quality = '<strong>' + _js('Poor') + ':</strong> ' + _js('You need a better title.');
            QuestionAsk.markFinished(qaTitleLabel, false);
            break;
         }
         case 3: {
            quality =
               '<strong>' + _js('Meh') + ':</strong> ' + _js('Not bad, could use some work.');
            QuestionAsk.markFinished(qaTitleLabel, false);
            break;
         }
         case 4:
         case 5: {
            quality =
               '<strong>' +
               _js('Great!') +
               ':</strong> ' +
               _js('Strong titles get strong answers.');
            QuestionAsk.markFinished(qaTitleLabel, true);
            break;
         }
      }

      qualityBar.set('data-score', score);
      qualityText.set('html', quality);

      if (qualityPoints > 0) {
         qualityBar.show();
      } else {
         qualityBar.hide();
      }
   },

   checkTitle: function () {
      let title = $('qaTitle');
      let titleText = title.get('value').clean();

      if (titleText.length <= 0 || titleText.startsWith('Example:')) {
         QuestionAsk.handleQualityBar(0);
         return 0; // We want to have 0 quality for an empty field.
      }

      let wordCount = getWordCount(titleText);

      let minPoints = 5;
      let qualityPoints = 0;
      let noQuestionMark = true;
      let asksForHelp = false;
      let usesPunctuation = false;
      let usesLower = false;
      let usesCaps = false;
      let criticalProblem = false; // If this is true, force to poor.
      let lastChar = titleText.charAt(titleText.length - 1);

      // Good wordcount is good for points.
      if (wordCount > 25) {
         qualityPoints += 1;
         criticalProblem = true;
      } else if (wordCount < 6) {
         qualityPoints += wordCount;
         if (wordCount < 4) {
            criticalProblem = true;
         }
      } else {
         qualityPoints += 6;
      }

      // End with question mark, good for points.
      // Check the question character for Japanese as well
      if (titleText.length > 1 && (lastChar == '?' || lastChar == '？')) {
         qualityPoints += 1;
         noQuestionMark = false;
      }

      if (titleText.search(/help/i) == -1) {
         qualityPoints += 1;
      } else {
         asksForHelp = true;
      }

      if (titleText.search(/[^\d\sA-Za-z-]+/) != -1) {
         usesPunctuation = true;
         qualityPoints += 1;
      }

      if (titleText.search(/[A-Z]/) != -1) {
         usesCaps = true;
      }

      // 0 points for all caps.
      // 1 point for all lower.
      // 2 points for caps and lower.
      if (titleText.search(/[a-z]/) != -1) {
         usesLower = true;
         qualityPoints += usesCaps ? 2 : 1;
      }

      if (criticalProblem && qualityPoints > minPoints) {
         qualityPoints = minPoints;
      }

      let msg = '';

      if (titleText.length > 0 && wordCount < 4) {
         msg = _js('Your title must have at least four words.');
      } else if (wordCount > 25) {
         msg = _js('Your title is too long.');
      } else if (!usesLower) {
         msg = _js("Don't make your post in all caps.");
      } else if (!usesCaps) {
         msg = _js('Try to capitalize your post properly.');
      } else if (!usesPunctuation) {
         msg = _js('You might want to add some punctuation.');
      } else if (noQuestionMark) {
         msg = _js('Try to use a question mark at the end.');
      } else if (asksForHelp) {
         msg = _js("You don't need to ask for help in your title.");
      }

      QuestionAsk.handleQualityBar(qualityPoints);

      return qualityPoints;
   },

   checkText: function () {
      let text = getText(editorid).clean();

      if (text.length < App.POST_MIN_CHARS) {
         QuestionAsk.markFinished($$('.js-qa-text-label)'), false);
      } else {
         QuestionAsk.markFinished($$('.js-qa-text-label'), true);
      }
   },

   // Mark a step as finished by adding a checkmark.
   markFinished: function (label, finished) {
      let number = label.getElement('.unfinished');
      let symbol = label.getElement('.finished');

      number.toggleClass('hidden', finished);
      symbol.toggleClass('hidden', !finished);
   },
};

export default QuestionAsk;
